// extracted by mini-css-extract-plugin
export default {"sort-menu__option-inner":"lsf-sort-menu__option-inner","sort-menu__title":"lsf-sort-menu__title","sort-menu__icon":"lsf-sort-menu__icon","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380594
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  